var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 107,
    viewBox: "0 0 109 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3309 96.974C68.8132 96.974 87.8494 77.9364 87.8494 54.4524C87.8494 30.9683 68.8132 11.9307 45.3309 11.9307C21.8486 11.9307 2.8125 30.9683 2.8125 54.4524C2.8125 77.9364 21.8486 96.974 45.3309 96.974Z",
    fill: "#E5EFEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36719 0.837891V4.53543",
    stroke: "#4C241D",
    strokeWidth: 1.09934,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36719 11.9307V15.6282",
    stroke: "#4C241D",
    strokeWidth: 1.09934,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.96875 8.2334H4.666",
    stroke: "#4C241D",
    strokeWidth: 1.09934,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0625 8.2334H15.7598",
    stroke: "#4C241D",
    strokeWidth: 1.09934,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3586 33.5C10.3593 33.891 10.2441 34.2735 10.0274 34.599C9.81066 34.9245 9.50228 35.1784 9.14125 35.3285C8.78021 35.4787 8.38275 35.5183 7.99917 35.4425C7.61558 35.3666 7.26311 35.1787 6.98637 34.9025C6.70963 34.6262 6.52105 34.2741 6.44449 33.8906C6.36794 33.5071 6.40686 33.1096 6.55632 32.7482C6.70579 32.3869 6.95908 32.078 7.28414 31.8607C7.6092 31.6433 7.99142 31.5273 8.38243 31.5273C8.90576 31.5278 9.40756 31.7357 9.77796 32.1054C10.1484 32.4752 10.3571 32.9766 10.3586 33.5Z",
    fill: "#4C241D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8545 39.6621C95.0012 39.6621 100.795 33.868 100.795 26.7207C100.795 19.5734 95.0012 13.7793 87.8545 13.7793C80.7077 13.7793 74.9141 19.5734 74.9141 26.7207C74.9141 33.868 80.7077 39.6621 87.8545 39.6621Z",
    fill: "white",
    stroke: "#4C241D",
    strokeWidth: 1.09934,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9443 39.6621C45.0911 39.6621 50.8847 33.868 50.8847 26.7207C50.8847 19.5734 45.0911 13.7793 37.9443 13.7793C30.7975 13.7793 25.0039 19.5734 25.0039 26.7207C25.0039 33.868 30.7975 39.6621 37.9443 39.6621Z",
    fill: "white",
    stroke: "#4C241D",
    strokeWidth: 1.09934,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5307 39.662C80.8784 39.8864 75.5367 42.3069 71.6412 46.4088C67.7457 50.5107 65.6037 55.9705 65.6707 61.6272V69.2423C65.6707 70.2229 65.2812 71.1634 64.5879 71.8568C63.8945 72.5502 62.9541 72.9398 61.9735 72.9398C60.9929 72.9398 60.0525 72.5502 59.3591 71.8568C58.6658 71.1634 58.2762 70.2229 58.2762 69.2423V61.6272C58.3433 55.9702 56.201 50.5101 52.3052 46.4082C48.4093 42.3062 43.067 39.8859 37.4145 39.662C34.5894 39.6091 31.7822 40.12 29.1568 41.1648C26.5315 42.2096 24.1407 43.7673 22.1244 45.7468C20.108 47.7264 18.5064 50.088 17.4132 52.6938C16.3201 55.2995 15.7573 58.097 15.7578 60.9228V72.9398C15.7578 81.7656 19.2636 90.23 25.5039 96.4708C31.7442 102.712 40.2079 106.218 49.0331 106.218H74.9139C83.739 106.218 92.2027 102.712 98.4431 96.4708C104.683 90.23 108.189 81.7656 108.189 72.9398V60.9228C108.19 58.0969 107.627 55.2992 106.534 52.6933C105.44 50.0875 103.839 47.7257 101.822 45.7461C99.8054 43.7666 97.4144 42.2089 94.7889 41.1643C92.1633 40.1196 89.3559 39.6089 86.5307 39.662Z",
    fill: "white",
    stroke: "#4C241D",
    strokeWidth: 1.09934,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6535 51.958C68.3357 51.9823 65.162 53.3174 62.8245 55.6722C60.4864 53.3169 57.312 51.9818 53.9936 51.958C46.6804 51.958 40.75 58.4509 40.75 66.4616C40.75 74.4723 56.2027 88.2161 62.8245 93.0506C69.4462 88.2161 84.9008 74.4705 84.9008 66.469C84.9008 58.4675 78.9685 51.958 71.6535 51.958Z",
    fill: "#F53E28",
    stroke: "#4C241D",
    strokeWidth: 1.09934,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.efdee30ddf09c404d937ce1d2b1dc2e6.svg";
export { ForwardRef as ReactComponent };